import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	skipToJiraNavigation: {
		id: 'page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation',
		defaultMessage: 'Skip to Jira Navigation',
		description:
			'Accessibility title for skipping to the top navigation section of Jira. Shows when tabbing first time on a page',
	},
	skipToSideNavigation: {
		id: 'page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation',
		defaultMessage: 'Skip to Side Navigation',
		description:
			'Accessibility title for skipping to the Jira left Side Navigation section. Shows when tabbing first time on a page',
	},
	skipToProjectViewNavigation: {
		id: 'page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation',
		defaultMessage: 'Skip to View Navigation',
		description:
			'Accessibility title for skipping to the view navigation section of Jira. Shows when tabbing first time on a page',
	},
	skipToMainContent: {
		id: 'page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content',
		defaultMessage: 'Skip to Main Content',
		description:
			'Accessibility title for skipping to the main content section of Jira. Shows when tabbing first time on a page',
	},
});
